import React from 'react'
import styles from "./Loader.module.scss"

const Loader = () => {
  return (
    <span className={styles.loader}></span>
  )
}

export default Loader